import React, { PureComponent } from 'react';
import renderRadioButtonField from '../../../components/RadioButton';
import renderCheckBoxField from '../../../components/form/CheckBox';
import renderSelectField from '../../../components/form/Select';
import renderDateField from '../../../components/form/DatePicker';
import renderMultiSelectField from '../../../components/form/MultiSelect';
import renderDropZoneField from '../../../components/form/DropZone';
import SliderWithScale from '../../range_sliders/components/SliderWithScale'
import { Field } from 'redux-form';
import uuid from 'uuid'
import PropTypes from 'prop-types';
import ToolTip from '../../tooltips/components/TooltipRight';
import { Container, Row, Col } from 'reactstrap';
import '../../../scss/component/assessments/question.scss';

export class RadioAnswers extends PureComponent {
  renderAnswers(id) {
    const { answers } = this.props;


    return answers.options ? answers.options.map(ans => {
      return <Col md={4} lg={4} xl={4} key={uuid()}>
        <Field
          name={id}
          component={renderRadioButtonField}
          label={ans}
          radioValue={ans.toLowerCase()}
          key={uuid()}
        />
      </Col>
    })
      : null
  }

  render() {
    const groupId = uuid();
    return (
      <div className='form__form-group question'>
        <label className='form__form-group-label'>
          <div>
            <b>{this.props.question} {this.props.helpText ? <ToolTip helpText={this.props.helpText} /> : null}</b>
          </div>
        </label>
        <div className='form__form-group-field'>
          <Container>
            <Row md={12}>
              {this.renderAnswers(groupId)}
            </Row>
          </Container>
        </div>
      </div>
    )
  }
}

export class CheckBoxAnswers extends PureComponent {
  renderAnswer() {
    const { answers } = this.props;

    return answers.options.map(ans => {
      return <Col md={4} lg={4} key={uuid()}>
        <Field
          name={uuid()} //name need to have a unique identifier
          component={renderCheckBoxField}
          label={ans}
          checkboxValue={ans.toLowerCase()}
        />
      </Col>
    })
  }

  render() {
    return (
      <div className='form__form-group question'>
        <label className='form__form-group-label'>
          <div>
            <b>{this.props.question} {this.props.helpText ? <ToolTip helpText={this.props.helpText} /> : null}</b>
          </div>
        </label>
        <div className='form__form-group-field'>
          <Container>
            <Row md={12} lg={12} key={uuid()}>
              {this.renderAnswer()}
            </Row>
          </Container>
        </div>
      </div>
    )
  }
}

export class TextAnswers extends PureComponent {
  renderAnswer() {

    return <Field
      name='defaultInput'
      component='input'
      type='text'
      placeholder='Default Input'
    />
  }

  render() {
    return (
      <div className='form__form-group question'>
        <label className='form__form-group-label'>
          <div>
            <b>{this.props.question} {this.props.helpText ? <ToolTip helpText={this.props.helpText} /> : null}</b>
          </div>
        </label>
        <div className='form__form-group-field'>
          {this.renderAnswer()}
        </div>
      </div>
    )
  }
}

export class UploadAnswers extends PureComponent {
  renderAnswer() {

    return <Field
      name='file'
      component={renderDropZoneField}
      type='text'
      placeholder='Default Input'
    />
  }

  render() {
    return (
      <div className='form__form-group question'>
        <label className='form__form-group-label'>
          <div>
            <b>{this.props.question} {this.props.helpText ? <ToolTip helpText={this.props.helpText} /> : null}</b>
          </div>
        </label>
        <div className='form__form-group-field'>
          {this.renderAnswer()}
        </div>
      </div>
    )
  }
}

export class MultiSelectAnswers extends PureComponent {
  renderAnswers() {
    const { answers } = this.props;

    return <Field
      name='multiSelect'
      component={renderMultiSelectField}
      options={answers.map(answer => { return { value: answer, label: answer } })}
      key={uuid()} />
  }

  render() {
    return (
      <div className='form__form-group question'>
        <label className='form__form-group-label'>
          <div>
            <b>{this.props.question} {this.props.helpText ? <ToolTip helpText={this.props.helpText} /> : null}</b>
          </div>
        </label>
        <div className='form__form-group-field'>
          {this.renderAnswers()}
        </div>
      </div>
    )
  }
}

export class SliderAnswers extends PureComponent {
  renderAnswers() {
    return <SliderWithScale dragging={0} />
  }

  render() {
    return (
      <div className='form__form-group question'>
        <label className='form__form-group-label'>
          <div>
            <b>{this.props.question} {this.props.helpText ? <ToolTip helpText={this.props.helpText} /> : null}</b>
          </div>
        </label>
        <div className='form__form-group-field'>
          {this.renderAnswers()}
        </div>
      </div>
    )
  }
}

export class DropdownAnswers extends PureComponent {
  renderAnswers() {
    const { answers } = this.props;
    return <Field
      name='select'
      component={renderSelectField}
      options={answers.map(answer => { return { value: answer, label: answer } })}
      key={uuid()}
    />
  }

  render() {
    return (
      <div className='form__form-group question'>
        <label className='form__form-group-label'>
          <div>
            <b>{this.props.question} {this.props.helpText ? <ToolTip helpText={this.props.helpText} /> : null}</b>
          </div>
        </label>
        <div className='form__form-group-field'>
          {this.renderAnswers()}
        </div>
      </div>
    )
  }
}

export class DateAnswers extends PureComponent {
  renderAnswers() {
    return <Field
      name='default_date'
      component={renderDateField}
      key={uuid()}
    />
  }

  render() {
    return (
      <div className='form__form-group question'>
        <label className='form__form-group-label'>
          <div>
            <b>{this.props.question} {this.props.helpText ? <ToolTip helpText={this.props.helpText} /> : null}</b>
          </div>
        </label>
        <div className='form__form-group-field'>
          {this.renderAnswers()}
        </div>
      </div>
    )
  }
}

export class Question extends PureComponent {
  static propTypes = {
    questionType: PropTypes.string,
    question: PropTypes.string,
    answers: PropTypes.string
  };

  render() {
    const answers = JSON.parse(this.props.answers)
    return (
      <div>
        {
          answers.type === 'radio' ?
            <RadioAnswers helpText={this.props.helpText} answers={answers} question={this.props.question} />
            : answers.type === 'checkbox' ?
              <CheckBoxAnswers helpText={this.props.helpText} answers={answers} question={this.props.question} />
              : answers.type === 'multiselect' ?
                <MultiSelectAnswers helpText={this.props.helpText} answers={answers} question={this.props.question} />
                : answers.type === 'dropdown' ?
                  <DropdownAnswers helpText={this.props.helpText} answers={answers} question={this.props.question} />
                  : answers.type === 'range' ?
                    <SliderAnswers helpText={this.props.helpText} question={this.props.question} />
                    : answers.type === 'text' ?
                      <TextAnswers helpText={this.props.helpText} question={this.props.question} />
                      : answers.type === 'upload' ?
                        <UploadAnswers helpText={this.props.helpText} question={this.props.question} />
                        : answers.type === 'Date' ?
                          <DateAnswers helpText={this.props.helpText} question={this.props.question} />
                          : null
        }
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/assessment/components/Question.js